import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { MaintenanceService } from './maintenance.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard  {
  maintenanceInfo$: Observable<any>;

  constructor(
    private maintenanceService: MaintenanceService,
    private router: Router) { 
      this.maintenanceInfo$ = this.maintenanceService.getMaintenanceState();
    }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this.maintenanceInfo$.pipe(
        map(state => !state?.[route?.routeConfig?.path]),
        tap(canAccess => {
          if (!canAccess) {
            this.router.navigate(['/home'])
          }
        })
      );
  }

}
